import * as React from "react";

import classNames from "classnames";

import DocBookmark from "../BlockNodeHelpers/Bookmark";
import DocNote from "../BlockNodeHelpers/Note";
import DocListItem from "./List/ListItem";

import { backgroundStyleFromNode } from "../../../helpers/Doc/changes";

interface DocListProps extends DocListType<InlineNode>, BlockNodeAll {};

function DocList(props: DocListProps) {
  const listItems = props.content.map((listItem, index) => {
    return (
      <DocListItem
        {...listItem}
        key={listItem.uid}
        simple={props.simple}
        documentContext={props.documentContext}
        currentVersion={props.currentVersion}
        editingContext={props.editingContext}
        userContext={props.userContext}
        displayContext={props.displayContext}
      />
    );
  });

  switch (props.type) {
    case "numberedList": {
      const listClass = classNames(
        props.simple ? "doc-numbered-list-simple" : "doc-numbered-list",
      );
      if (props.simple) {
        return (
          <ol
            id={props.uid}
            data-is-node
            data-uid={props.uid}
            className={classNames(listClass, props.uid, props.classes, {
              "focused-bookmark": props.isFocusedBookmark && !props.simple,
            })}
            style={backgroundStyleFromNode(props)}
          >
            {listItems}
          </ol>
        );
      }
      return (
        <div
          id={props.uid}
          data-is-node
          data-uid={props.uid}
          className={classNames("doc-list-node", props.uid, props.classes, {
            "focused-bookmark": props.isFocusedBookmark,
          })}
          style={backgroundStyleFromNode(props)}
        >
          <ol className={listClass}>{listItems}</ol>
          <DocNote {...props} />
          <DocBookmark {...props} />
        </div>
      );
    }
    case "regularList":
    default: {
      const listClass = classNames(
        props.simple ? "doc-regular-list-simple" : "doc-regular-list",
      );
      if (props.simple) {
        return (
          <ul
            id={props.uid}
            data-is-node
            data-uid={props.uid}
            className={classNames(listClass, props.uid, props.classes, {
              "focused-bookmark": props.isFocusedBookmark && !props.simple,
            })}
            style={backgroundStyleFromNode(props)}
          >
            {listItems}
          </ul>
        );
      }
      return (
        <div
          id={props.uid}
          data-is-node
          data-uid={props.uid}
          className={classNames("doc-list-node", props.uid, props.classes, {
            "focused-bookmark": props.isFocusedBookmark,
          })}
          style={backgroundStyleFromNode(props)}
        >
          <ul className={listClass}>{listItems}</ul>
          <DocNote {...props} />
          <DocBookmark {...props} />
        </div>
      );
    }
  }
}

export default React.memo(DocList);
